import { useTranslation } from 'react-i18next';
import { useContent } from '../contexts/ContentContext';

export const TrustStats = () => {
  const { t } = useTranslation();
  const { getValue } = useContent();

  return (
    <section
      id="trust-stats"
      data-section="trust-stats"
      className="py-10 border-t border-regai bg-[linear-gradient(120deg,rgba(79,70,229,0.18)_0%,rgba(124,58,237,0.14)_45%,rgba(79,70,229,0.2)_100%)] dark:bg-[rgba(15,23,42,0.65)] animate-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-4 card-group">
          <div className="card bg-regai-surface">
            <div className="text-3xl font-extrabold text-regai">
              {getValue('stats.modules', t('stats.modules'))}
            </div>
            <div className="text-sm text-regai-muted mt-1">
              {getValue('stats.modulesLabel', t('stats.modulesLabel'))}
            </div>
          </div>
          <div className="card bg-regai-surface">
            <div className="text-3xl font-extrabold text-regai">
              {getValue('stats.students', t('stats.students'))}
            </div>
            <div className="text-sm text-regai-muted mt-1">
              {getValue('stats.studentsLabel', t('stats.studentsLabel'))}
            </div>
          </div>
          <div className="card bg-regai-surface">
            <div className="text-3xl font-extrabold text-regai">
              {getValue('stats.rating', t('stats.rating'))}
            </div>
            <div className="text-sm text-regai-muted mt-1">
              {getValue('stats.ratingLabel', t('stats.ratingLabel'))}
            </div>
          </div>
        </div>
        <div className="mt-6 text-center text-sm text-regai-muted">
          {getValue('stats.disclaimer', t('stats.disclaimer'))}
        </div>
      </div>
    </section>
  );
};
